import React from "react";

import { Props } from "./types";
import styles from "./styles.scss";
import { ResourceAvatar } from "@common/resourceAvatar";

function InfoUser({ resource }: Props) {
  return (
    <div className={styles.dataUser}>
      <div className={styles.avatar}>
        <ResourceAvatar resource={resource} />
      </div>
      <div className={styles.resourceBox}>
        <p className={styles.name}>{resource.name}</p>
        {resource.profession && (
          <p className={styles.profession}>{resource.profession}</p>
        )}
      </div>
    </div>
  );
}

export { InfoUser };
